import { List, MagnifyingGlass } from "@phosphor-icons/react";
import Link from "astro-typesafe-routes/link/react";
import type React from "react";
import { useState } from "react";

import type { Locale } from "~/i18n";

import { Menu, MenuAction, MenuButton, MenuList } from "../Menu";
import { Modal } from "../Modal";
import { NavItems } from "./NavItems";

export const MobileNav: React.FC<{
  children: React.ReactElement;
  locale: Locale;
}> = ({ children, locale }) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  return (
    <>
      <Menu placement="start">
        <MenuButton className="btn btn-square btn-ghost">
          <List className="size-7" />
        </MenuButton>
        <MenuList>
          <ul className="menu">
            <li className="md:hidden">
              <MenuAction
                onClick={() => {
                  setIsSearchOpen(true);
                }}
              >
                <MagnifyingGlass className="size-4" weight="bold" />
                Search
              </MenuAction>
            </li>
            <NavItems locale={locale} />
            <li>
              <Link to="/support/guides">Guides</Link>
            </li>
            <li>
              <Link to="/blog">Blog</Link>
            </li>
          </ul>
        </MenuList>
      </Menu>
      <Modal
        type="unstyled"
        isOpen={isSearchOpen}
        onClose={() => {
          setIsSearchOpen(false);
        }}
      >
        {children}
      </Modal>
    </>
  );
};
